<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title" *ngIf="PopupFor==1">
      Columns<!--  {{ title }} -->
    </span>
    <span class="ttmodal__title" *ngIf="PopupFor==2">
      Dates<!--  {{ title }} -->
    </span>
    <span class="ttmodal__title" *ngIf="PopupFor==3">
      Legend<!--  {{ title }} -->
    </span>
    <span class="ttmodal__title" *ngIf="PopupFor==5">
      Interval<!--  {{ title }} -->
    </span>
    <span class="ttmodal__title" *ngIf="PopupFor==4">
      Components<!--  {{ title }} -->
    </span>

    <span class="ttmodal__title" *ngIf="PopupFor==6 ">
      Create Favorite<!--  {{ title }} -->
    </span>

    <span class="ttmodal__title" *ngIf="PopupFor==15 ">
      Update Favorite<!--  {{ title }} -->
    </span>

    <span class="ttmodal__title" *ngIf="PopupFor==16 ">
      Delete Favorite<!--  {{ title }} -->
    </span>

    <span class="ttmodal__title" *ngIf="PopupFor==8">
      Select equipment to create action recommendation
    </span>
    <span class="ttmodal__title" *ngIf="PopupFor==112">
      Recommendation<!--  {{ title }} -->
    </span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>

  <div *ngIf="PopupFor==1">
    <div class="ttmodal__body">
      <mat-checkbox [labelPosition]="before" [value]="1"
        (change)="OnColumnCheckBoxSlected(ColumnList.Make, $event.checked)"
        [(ngModel)]="ColumnList.Make">Make</mat-checkbox><br>
      <!-- <mat-checkbox [labelPosition]="before" [value]="2" (change)="OnColumnCheckBoxSlected(ColumnList.AVGDailyUse, $event.checked)"  [(ngModel)]="ColumnList.AVGDailyUse">Average Daily Use</mat-checkbox><br> -->
      <mat-checkbox [labelPosition]="before" [value]="3"
        (change)="OnColumnCheckBoxSlected(ColumnList.LastInspection, $event.checked)"
        [(ngModel)]="ColumnList.LastInspection">Last Worn %</mat-checkbox><br>
      <mat-checkbox [labelPosition]="before" [value]="4"
        (change)="OnColumnCheckBoxSlected(ColumnList.Position, $event.checked)" [(ngModel)]="ColumnList.Position">Worn %
        Today</mat-checkbox><br>
      <mat-checkbox [labelPosition]="before" [value]="5"
        (change)="OnColumnCheckBoxSlected(ColumnList.NextPmService, $event.checked)"
        [(ngModel)]="ColumnList.NextPmService">Next PM Service %</mat-checkbox><br>
      <mat-checkbox [labelPosition]="before" [value]="6"
        (change)="OnColumnCheckBoxSlected(ColumnList.SecondPmService, $event.checked)"
        [(ngModel)]="ColumnList.SecondPmService">2nd PM Service %</mat-checkbox><br>
      <mat-checkbox [labelPosition]="before" [value]="7"
        (change)="OnColumnCheckBoxSlected(ColumnList.Worn_100, $event.checked)" [(ngModel)]="ColumnList.Worn_100">100 %
        Worn Date</mat-checkbox><br>
      <mat-checkbox [labelPosition]="before" [value]="8"
        (change)="OnColumnCheckBoxSlected(ColumnList.Worn_120, $event.checked)" [(ngModel)]="ColumnList.Worn_120">120 %
        Worn Date </mat-checkbox><br>
      <mat-checkbox [labelPosition]="before" [value]="9"
        (change)="OnColumnCheckBoxSlected(ColumnList.CMU, $event.checked)"
        [(ngModel)]="ColumnList.CMU">CMU</mat-checkbox><br>
      <mat-checkbox [labelPosition]="before" [value]="10"
        (change)="OnColumnCheckBoxSlected(ColumnList.DOC, $event.checked)"
        [(ngModel)]="ColumnList.DOC">DOC</mat-checkbox><br>
      <!-- <mat-checkbox [(ngModel)]="hideRequiredControl">Hide required marker</mat-checkbox> -->
    </div>
    <div class="ttmodal__footer">
      <button mat-raised-button (click)="onNoClick()">Cancel</button>
      <button mat-raised-button color="warn" [class.loading]="saving" (click)="CheckBoxChangeSave()">
        Save
      </button>
    </div>
  </div>
  <div *ngIf="PopupFor==3">
    <p><strong>Graphs – Green Line</strong></p>
    <p>Shows the expected life of the component</p>
    <p><strong>Graphs – Blue Line</strong></p>
    <p>Shows the extended life of the component due to the recommended action</p>
    <p><strong>Graphs – Blue Icon</strong></p>
    <p>Shows where an action has been recommended</p>
  </div>

  <div *ngIf="PopupFor==2">
    <mat-form-field class="date-width">
      <input matInput [matDatepicker]="picker" placeholder="Start Date" [(ngModel)]="startDate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <input type="number" matInput placeholder="Enter month" [(ngModel)]="Month" (focusout)="onInputFocusOut()">
    </mat-form-field>

    <mat-form-field class="date-width">
      <input matInput [matDatepicker]="picker1" placeholder="End Date" [(ngModel)]="endDate">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>

    <div class="ttmodal__footer">
      <button mat-raised-button (click)="onNoClick()">Cancel</button>
      <button mat-raised-button color="warn" [class.loading]="saving" (click)="SaveDate()">
        Save
      </button>
    </div>
  </div>

  <div *ngIf="PopupFor==4">
    <div class="ttmodal__body">
      <!-- jjkdhfjs -->
      <mat-checkbox [(ngModel)]="masterSelected" (change)="toggleAll($event.checked)">
        <span *ngIf="!SelectedAll">Select All</span>
        <span *ngIf="SelectedAll">Unselect All</span>
      </mat-checkbox>
      <hr style="margin-top:3px;margin-bottom:3px">
      <p style="font-weight: 600;font-size: 16px; padding:10px">Track Components</p>

      <mat-checkbox [value]="102" (change)="onCheckboxChange(102, $event.checked)" [(ngModel)]="SummaryTrackStock"
        [disabled]="isMaxReached && !SummaryTrackStock">Summary Tracks</mat-checkbox><br>
      <mat-checkbox [value]="230" [(ngModel)]="Link" (change)="onCheckboxChange(230, $event.checked)"
        [disabled]="isMaxReached && !Link">Link</mat-checkbox><br>

      <mat-checkbox [value]="231" [(ngModel)]="Bush" (change)="onCheckboxChange(231, $event.checked)"
        [disabled]="isMaxReached && !Bush">Bush</mat-checkbox><br>

      <mat-checkbox [value]="232" [(ngModel)]="Shoe" (change)="onCheckboxChange(232, $event.checked)"
        [disabled]="isMaxReached && !Shoe">Shoe</mat-checkbox><br>

      <p style="font-weight: 600; font-size: 16px; padding:10px">Rolling Components</p>

      <mat-checkbox [value]="101" [(ngModel)]="SummaryRollingStock" (change)="onCheckboxChange(101, $event.checked)"
        [disabled]="isMaxReached && !SummaryRollingStock">Summary Rolling Stock</mat-checkbox><br>
      <mat-checkbox [value]="233" [(ngModel)]="Idlers" (change)="onCheckboxChange(233, $event.checked)"
        [disabled]="isMaxReached && !Idlers">Idler</mat-checkbox><br>
      <mat-checkbox [value]="235" [(ngModel)]="TrackRoller" (change)="onCheckboxChange(235, $event.checked)"
        [disabled]="isMaxReached && !TrackRoller">Track Roller</mat-checkbox><br>
      <mat-checkbox [value]="234" [(ngModel)]="CarrierRoller" (change)="onCheckboxChange(234, $event.checked)"
        [disabled]="isMaxReached && !CarrierRoller">Carrier Roller</mat-checkbox><br>
      <mat-checkbox [value]="236" [(ngModel)]="Sprocket" (change)="onCheckboxChange(236, $event.checked)"
        [disabled]="isMaxReached && !Sprocket">Sprocket</mat-checkbox><br>
      <mat-checkbox [value]="103" [(ngModel)]="TFrame" (change)="onCheckboxChange(103, $event.checked)"
        [disabled]="isMaxReached && !TFrame">Track Frame</mat-checkbox><br>



      <!-- <mat-checkbox [(ngModel)]="hideRequiredControl">Hide required marker</mat-checkbox> -->
    </div>
    <div class="ttmodal__footer">
      <button mat-raised-button (click)="onNoClick()">Cancel</button>
      <button mat-raised-button color="warn" [class.loading]="saving" (click)="CheckBoxChangeSave()">
        Save
      </button>
    </div>

  </div>

  <div *ngIf="PopupFor==5">
    <div class="ttmodal__body">
      <mat-radio-group [(ngModel)]="interval">
        <mat-radio-button [value]="1">Weekly</mat-radio-button>
        <mat-radio-button [value]="2">Monthly</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="ttmodal__footer">
      <button mat-raised-button (click)="IntervelClose()">Cancel</button>
      <button mat-raised-button color="warn" [class.loading]="saving" (click)="IntervelClose()">
        Save
      </button>
    </div>

  </div>

  <div *ngIf="PopupFor==6 ||PopupFor==15 ||PopupFor==16">
    <div class="ttmodal__body">
      <mat-form-field class="mat-input-width">
        <input type="text" matInput name="Name" [(ngModel)]="Name" #pitch_="ngModel" placeholder="Name">
      </mat-form-field>

      <mat-form-field class="mat-input-width">
        <!-- <mat-select placeholder="Background Color " name="bgColor" [(ngModel)]="bgColor" #bColor="ngModel">
          <mat-option [value]="1">Blue</mat-option>
          <mat-option [value]="2">Green</mat-option>
          <mat-option [value]="3">Red</mat-option>
          <mat-option [value]="4">Brown</mat-option>

        </mat-select> -->

        <mat-select id="background" required [(ngModel)]="bgColor" name="bgColor" #modelbackground="ngModel">
          <mat-option *ngFor="let color of availableColors" [value]="color.Colour">{{color.Name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="mat-input-width">

        <mat-select id="text" required [(ngModel)]="textColor" #modeltext="ngModel" name="textcolor">
          <mat-option *ngFor="let color of availableColors" [value]="color.Colour">{{color.Name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="ttmodal__footer">
      <button mat-raised-button (click)="onNoClick()">Cancel</button>
      <button mat-raised-button color="warn" *ngIf="this.PopupFor==6" [class.loading]="saving"
        (click)="submitDialog(1)">
        Save
      </button>

      <button mat-raised-button color="warn" *ngIf="this.PopupFor==15" [class.loading]="saving"
        (click)="submitDialog(2)">Update</button>

      <button mat-raised-button color="warn" *ngIf="this.PopupFor==16" [class.loading]="saving"
        (click)="submitDialog(3)">Delete</button>
    </div>
  </div>

  <div *ngIf="PopupFor==8">
    <div class="ttmodal__body">
      <mat-form-field class="mat-input-width">
        <input matInput #customerAutoCompleteInput placeholder="Customer" aria-label="customer"
          [matAutocomplete]="autoCustomer" [formControl]="customerCtrl">
        <mat-autocomplete #autoCustomer="matAutocomplete"
          (optionSelected)="customerSelected($event,customerAutoCompleteInput )">
          <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer">
            <span>{{ customer.Title }}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field class="mat-input-width">

        <input matInput #jobSiteAutoCompleteInput placeholder="JobSite" aria-label="jobsite"
          [matAutocomplete]="autoJobsite" [formControl]="jobsiteCtrl">

        <!-- [displayWith]="jobsiteDisplayMapper" -->
        <mat-autocomplete #autoJobsite="matAutocomplete"
          (optionSelected)="jobsiteSelected($event, jobSiteAutoCompleteInput)">
          <mat-option *ngFor="let jobsite of filteredJobsites | async" [value]="jobsite">
            <!--<img style="vertical-align:middle;" aria-hidden src="" height="25" />-->
            <span>{{ jobsite.Title }}</span>
            <small></small>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>


      <!-- <mat-form-field class="mat-input-width">
        <mat-label>Select Jobsite</mat-label>
        <mat-select name="jobsite" placeholder="{{'Select Jobsite' | translate | async}}" [(ngModel)]="JobsiteId"
          (selectionChange)="GetEquipment()">
          <mat-option>None</mat-option>
          <mat-option *ngFor="let jobsite of jobSiteListFilter" [value]="jobsite.Id">
            {{ jobsite.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->

      <mat-form-field class="mat-input-width">
        <mat-select [autofocus]="true" #equipmentSelect placeholder="Select Equipment" name="Select Equipment"
          [(ngModel)]="selectedEquipment">
          <mat-option *ngFor="let equip of EquipmentModel" [value]="equip.Id">
            {{equip.Title}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="ttmodal__footer">
      <button mat-raised-button (click)="onNoClick()">Cancel</button>
      <button mat-raised-button color="warn" (click)="Navigateto()">
        Start
      </button>
    </div>
  </div>
  <div *ngIf="PopupFor==112">
    <div class="ttmodal__body">
      <div *ngFor="let item of QuoteDetailResult">

        <p><span style="font-weight: 600;font-size: 17px;color: dimgrey;">Recommendation :</span> {{item.ActionDescription}}</p>
          <p><span style="font-weight: 600;font-size: 17px;color: dimgrey;">Side:</span> {{item.Side}}</p>
         <p><span style="font-weight: 600;font-size: 17px;color: dimgrey;">Action Date :</span> {{item.ActionDate|date: 'dd MMM yyyy'}}</p>
          <p><span style="font-weight: 600;font-size: 17px;color: dimgrey;">Action SMU :</span> {{item.StartActionAtSmu}}</p>
                 <p><span style="font-weight: 600;font-size: 17px;color: dimgrey;">Hours Gained :</span> {{item.CompleteActionBySmu}}</p>
                  <p><span style="font-weight: 600;font-size: 17px;color: dimgrey;">Severity :</span> {{item.Severity}}</p>
          <p><span style="font-weight: 600;font-size: 17px;color: dimgrey;">PartCost :</span> {{item.PartsCost}}</p>
        <p><span style="font-weight: 600;font-size: 17px;color: dimgrey;">LabourCost :</span> {{item.LabourCost}}</p>
        <p><span style="font-weight: 600;font-size: 17px;color: dimgrey;">MiscCost :</span> {{item.MiscCost}}</p>
        <div class="ttmodal__footer">
            <button mat-raised-button color="warn" (click)="NavigateToAction()" style="cursor:pointer">Edit</button>
        </div>
      </div>
    </div>
  </div>